// frontend/src/components/learning-path/PathNode.tsx

import { Link } from 'react-router-dom';
import { LearningPathStep } from '../../types/courses.types';

const STATUS_ICON: Record<LearningPathStep['status'], string> = {
  completed: '✅',
  current: '📍',
  locked: '🔒',
};

const STATUS_BADGE: Record<LearningPathStep['status'], { label: string; className: string }> = {
  completed: { label: 'Tamamlandı', className: 'success' },
  current: { label: 'Devam Ediyor', className: 'primary' },
  locked: { label: 'Kilitli', className: 'warning' },
};

interface PathNodeProps {
  step: LearningPathStep;
  index: number;
}

export function PathNode({ step, index }: PathNodeProps) {
  const badge = STATUS_BADGE[step.status];

  const nodeStyle: React.CSSProperties = step.status === 'completed'
    ? { background: 'rgba(16, 185, 129, 0.08)', borderLeft: '3px solid #10b981' }
    : step.status === 'current'
    ? { borderLeft: '3px solid var(--primary-light)' }
    : {};

  const content = (
    <>
      <div className={`path-node-icon ${step.status}`}>{STATUS_ICON[step.status]}</div>
      <div className="path-node-info">
        <h4 style={step.status === 'completed' ? { color: '#10b981' } : undefined}>
          {index + 1}. {step.title}
        </h4>
        {step.description && <p>{step.description}</p>}
      </div>
      <div className="path-node-status">
        <span className={`lesson-badge ${badge.className}`}>{badge.label}</span>
      </div>
    </>
  );

  if (step.status === 'locked' || !step.lessonId) {
    return <div className="path-node locked" style={nodeStyle}>{content}</div>;
  }

  return (
    <Link to={`/lessons/${step.lessonId}`} className={`path-node ${step.status === 'current' ? 'active' : ''}`} style={nodeStyle}>
      {content}
    </Link>
  );
}
